import React from "react";
import "../../styles/quality.css";
const QualityBox = ({title,content}) => {
  return (
    <div className="quality-box">
      <h2>{title}</h2>
      <p>
        {content}
      </p>
    </div>
  );
};

export default QualityBox;
